module.exports = __webpack_public_path__ + "static/hero-top-2-91f5315a5edc0aee554f9c755377012b.png";